import React, {useCallback, useEffect, useState} from 'react';
import {useRecoilState} from 'recoil';
import {loadingAtom} from '../../atoms';
import {getPixKeyConfiguration, savePixKeyConfiguration} from '../../utils/requestUtils';
import './CompanyClosedDaysCalendar.css';

const PixKeyConfiguration = ({disabled = false}) => {
    const [, setLoading] = useRecoilState(loadingAtom);
    const [pixKey, setPixKey] = useState('');
    const [ownerName, setOwnerName] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [isDirty, setIsDirty] = useState(false);

    const resetFeedback = () => {
        setErrorMessage('');
        setSuccessMessage('');
    };

    const loadConfiguration = useCallback(async () => {
        resetFeedback();
        setLoading(true);
        try {
            const response = await getPixKeyConfiguration();
            setPixKey(response?.pixKey || '');
            setOwnerName(response?.ownerName || '');
            setIsDirty(false);
        } catch (error) {
            console.error('Erro ao carregar configuração de chave Pix:', error);
            setErrorMessage('Não foi possível carregar a configuração.');
        } finally {
            setLoading(false);
        }
    }, [setLoading]);

    useEffect(() => {
        loadConfiguration();
    }, [loadConfiguration]);

    const handleChange = (setter) => (e) => {
        resetFeedback();
        setter(e.target.value);
        setIsDirty(true);
    };

    const onSave = async () => {
        if (disabled || !isDirty) return;
        resetFeedback();
        setLoading(true);
        try {
            await savePixKeyConfiguration({pixKey: pixKey.trim(), ownerName: ownerName.trim()});
            setSuccessMessage('Configuração de chave Pix salva com sucesso.');
            setIsDirty(false);
        } catch (error) {
            console.error('Erro ao salvar configuração de chave Pix:', error);
            setErrorMessage('Não foi possível salvar a configuração. Tente novamente.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="company-closed-days-calendar">
            <div className="header-label">Chave Pix</div>

            <div style={{display: 'flex', flexDirection: 'column', gap: '12px', maxWidth: '320px', margin: '10px auto'}}>
                <div style={{display: 'flex', flexDirection: 'column'}}>
                    <label>Chave Pix:</label>
                    <input
                        type="text"
                        placeholder="email, CPF, telefone ou chave aleatória"
                        value={pixKey}
                        onChange={handleChange(setPixKey)}
                        disabled={disabled}
                        style={{width: '100%', boxSizing: 'border-box'}}
                    />
                </div>

                <div style={{display: 'flex', flexDirection: 'column'}}>
                    <label>Nome do titular:</label>
                    <input
                        type="text"
                        placeholder="Nome completo"
                        value={ownerName}
                        onChange={handleChange(setOwnerName)}
                        disabled={disabled}
                        style={{width: '100%', boxSizing: 'border-box'}}
                    />
                </div>

                <div style={{fontSize: '13px', color: '#555'}}>
                    Esses dados aparecem no resumo do pedido gerado para o WhatsApp.
                </div>
            </div>

            <div className="calendar-actions">
                <button onClick={loadConfiguration} disabled={disabled}>
                    Recarregar
                </button>
                <button onClick={onSave} disabled={disabled || !isDirty}>
                    Confirmar
                </button>
            </div>
            {successMessage && (
                <div className="calendar-status calendar-status-success">{successMessage}</div>
            )}
            {errorMessage && (
                <div className="calendar-status calendar-status-error">{errorMessage}</div>
            )}
        </div>
    );
};

export default PixKeyConfiguration;
